
export default {
    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },

        guest: {
            type: Object,
            default: () => {
                return {}
            },
        },

        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            answer: null,
        }
    },

    computed: {
        answers() {
            let answers = null
            try {
                answers = JSON.parse(this.event.answers)
            } catch (error) {
                answers = this.event.answers?.length || []
            }
            return answers
        },
    },

    watch: {
        model: {
            handler() {
                this.answer = this.event.answers?.length ? this.answers.find((el) => el.question === this.model.question)?.answer || null : null
            },
            immediate: true,
        },
    },

    methods: {
        saveAnswer() {
            let data = { answers: [{ question: this.model.question, answer: this.answer, is_optional: this.model.is_optional }] }

            if (this.answers?.length) {
                const answers = [...this.answers]
                const idx = answers.findIndex((el) => el.question === this.model.question)
                if (idx !== -1) answers[idx].answer = this.answer
                else answers.push({ question: this.model.question, answer: this.answer, is_optional: this.model.is_optional })
                data = { answers }
            }

            this.$axios.$put(`/api/v1/public/guests/${this.guest.id}/guest_wedding_events/${this.event.id}/status`, data).then((res) => {
                this.$emit('updated', { guest: this.guest, event: res.data })
            })
        },
    },
}
